// Disable linter for this part as it isn't aware of platformClient loaded in index.html
/* eslint-disable */
const client = platformClient.ApiClient.instance
client.setEnvironment('mypurecloud.com.au')

// GENESYS CLOUD IMPLICIT GRANT
const clientId = process.env.VUE_APP_CLIENT_ID;

// GENESYS CLOUD API
const usersApi = new platformClient.UsersApi()
const conversationsApi = new platformClient.ConversationsApi()
const notificationsApi = new platformClient.NotificationsApi()
const presenceApi = new platformClient.PresenceApi();
const routingApi = new platformClient.RoutingApi();
const voicemailApi = new platformClient.VoicemailApi();

import packageInfo from '../package.json'
import orgqueues from './components/OrgQueues.vue'
import walkin from './components/WalkIn.vue'

// VUE BEGINS
export default {
    name: "App",  
    components: {
        orgqueues,
        walkin,
      },
    data: () => ({
        cxlogiq: {
            appName: 'scaffold',
            appDisplayName: null,
            logging: true,
            version: null,
        },
        licensing: {
            mode: null,
            expires: null,
            contact: null,
            licenseDisplayString: null
        },
        licensed: false,
        urlParams: null,
        user: {
            id: null,
            name: null,
            email: null,
            division: null,
            roles: [],            
        },
        accessToken: 'yeah',
        tokenExpiryTime: null,
        organization: {
            id: null,
            name: null,
            domain: null,
        }
    }),
    created() {
        if (packageInfo.version) {
            this.log('[CXLOGiQ] '+ packageInfo.name + ' v' + packageInfo.version + ' is starting...')
            this.cxlogiq.version = packageInfo.version;
        }  
        // URLPARAMS — encode both query params and path so route survives OAuth redirect
        this.urlParams = JSON.stringify({ query: this.$route.query, path: this.$route.path });
        this.log('* URL Parameters: '+this.urlParams)
        // DEFINE CLIENT
        const client = platformClient.ApiClient.instance;
        client.setEnvironment("mypurecloud.com.au");
        client.setPersistSettings(true);
        // Generate Redirect URI
        const redirectUri = window.location.origin
        // INITIATE LOGIN
        this.loginImplicitGrant(redirectUri) 
    },
    methods: {
        // LOGGING
        log(message) {
            if (this.cxlogiq.logging) {
                console.log('[CXLOGiQ] '+message)
            }
        },
        // STARTUP
        loginImplicitGrant(redirectUri) {
            this.log('PureCloud ImplicitGrant requested')
            client.loginImplicitGrant(clientId, redirectUri, {state: this.urlParams})
            .then((data) => {  
                this.log('PureCloud ImplicitGrant success')
                const stateData = JSON.parse(data.state)
                console.log(stateData)
                if (stateData && stateData.query !== undefined) {
                    // New format: { query: {...}, path: '/...' }
                    this.urlParams = stateData.query
                    const targetPath = stateData.path
                    if (targetPath && targetPath !== '/' && this.$route.path !== targetPath) {
                        this.$router.push(targetPath).catch(() => {})
                    }
                } else {
                    // Backward compat: older state was just the query object
                    this.urlParams = stateData
                }
                this.accessToken = data.accessToken
                this.tokenExpiryTime = data.tokenExpiryTime
                this.scheduleTokenRefresh(data.tokenExpiryTime)
                this.getUsersMe()
            })
            .catch((err) => {
                this.log('PureCloud ImplicitGrant failure')
                this.log(err)
            })            
        },
        scheduleTokenRefresh(expiryTime) {
            const msUntilRefresh = expiryTime - Date.now() - (5 * 60 * 1000)
            // const msUntilRefresh = expiryTime - expiryTime + 20000 // For testing, refresh 20 seconds after login
            if (msUntilRefresh <= 0) {
                this.loginImplicitGrant(window.location.origin)
                return
            }
            this.log(`Token refresh scheduled in ${Math.round(msUntilRefresh / 60000)} minutes`)
            setTimeout(() => {
                this.loginImplicitGrant(window.location.origin)
            }, msUntilRefresh)
        },
        getUsersMe() {
            this.log('PureCloud getUsersMe requested')
            const opts = { 
                'expand': ["authorization","organization"],
              };
            usersApi.getUsersMe(opts)
            .then((data) => {
                this.log('PureCloud getUsersMe success')
                console.log(data)  
                this.user.id = data.id
                this.user.name = data.name  
                this.user.email = data.email 
                this.user.roles = data.authorization.roles     
                this.user.division = data.division.id
                this.organization.id = data.organization.id
                this.organization.name = data.organization.name
                this.organization.domain = data.organization.domain
                // this.phoneHome() 
            })
            .catch((err) => {
                this.log('PureCloud getUsersMe failure')
                this.log(err)
            })  
        },
        appMainStart() {
            this.log('######### '+ this.cxlogiq.appName + ' is Running! in '+ this.licensing.mode +' mode #########')
        }
    },
  };